import useSWRMutation from "swr/mutation";
import axiosInstance from "Api";

const mutationFetcher = async (url, { arg }) => {
    // Case 1: arg is a callback function
    if (typeof arg === "function") {
        const response = await arg();
        return response.data;
    }

    // Case 2: URL provided to hook
    if (url && url !== "mutation") {
        const response = await axiosInstance({
            url,
            method: arg?.method || "post",
            data: arg?.data,
            params: arg?.params,
        });

        return response.data;
    }

    throw new Error("No mutation handler provided");
};

export const useApiMutation = (url = "mutation") => {
    return useSWRMutation(url, mutationFetcher);
};